import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';

function Logo() {
    return (
        <Link to="/" className="flex items-center gap-3">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-white">
                <path d="M12 2l8.66 5v10l-8.66 5-8.66-5V7z" />
                <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            </svg>
            <span className="text-sm font-bold uppercase tracking-[0.2em]">GYMS.ar</span>
        </Link>
    );
}

export default function PublicShell({ children }) {
    return (
        <div className="min-h-screen bg-black text-white flex flex-col">
            {/* Navbar overlay */}
            <nav className="fixed top-0 left-0 right-0 z-50 bg-black/20">
                <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
                    <Logo />
                    <div className="flex items-center gap-5">
                        <Link to="/precios" className="hidden sm:flex items-center text-white/90 hover:text-white transition-colors uppercase text-xs tracking-[0.15em] font-medium">
                            Precios
                        </Link>
                        <Link to="/consulta-dni" className="hidden sm:flex items-center gap-2 text-white/90 hover:text-white transition-colors uppercase text-xs tracking-[0.15em] font-medium">
                            <Search className="h-4 w-4" />
                            Consultar DNI
                        </Link>
                        <Link to="/login" className="hidden sm:flex items-center text-white/90 hover:text-white transition-colors uppercase text-xs tracking-[0.15em] font-medium">
                            Ingresar
                        </Link>
                        <Link to="/register" className="hidden sm:block border border-white/60 rounded-full px-5 py-2 text-xs uppercase tracking-[0.15em] font-bold hover:bg-white hover:text-black transition-colors">
                            Registrarse
                        </Link>
                    </div>
                </div>
            </nav>

            <main className="flex-1">{children}</main>

            {/* Footer */}
            <footer className="border-t border-hairline-dark py-10 px-6 lg:px-10 bg-black">
                <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
                    <div className="flex flex-col sm:flex-row items-center gap-6">
                        <Logo />
                        <nav className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2">
                            <Link to="/precios" className="micro-cap text-white/60 hover:text-white transition-colors">Precios</Link>
                            <Link to="/legal/privacidad" className="micro-cap text-white/60 hover:text-white transition-colors">Privacidad</Link>
                            <Link to="/legal/terminos" className="micro-cap text-white/60 hover:text-white transition-colors">Términos</Link>
                            <Link to="/legal/pagos" className="micro-cap text-white/60 hover:text-white transition-colors">Pagos</Link>
                            <Link to="/legal/cookies" className="micro-cap text-white/60 hover:text-white transition-colors">Cookies</Link>
                        </nav>
                    </div>
                    <div className="flex items-center gap-4">
                        <p className="caption text-white/50">
                            <span className="hover:text-white transition-colors">GYMS.ar</span>
                            {' - Powered by '}
                            <a href="https://beira.ar" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Beira<span className="text-[#7ad03a]">.</span>ar</a>
                        </p>
                        <a
                            href="https://wa.me/5493872265797"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                            className="text-[#7ad03a] hover:text-white transition-colors"
                        >
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                            </svg>
                        </a>
                    </div>
                </div>
            </footer>
        </div>
    );
}
